let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("XRhye")).then(() => parcelRequire('7xUQe'));